<template>
  <div :id="id" @contextmenu.prevent="handler($event)"
       class="sitebuilder-element-container"
       element="BlogCategoriesListComponent"
       :data-hide-desktop="!this.internal_config.showDesktop"
       :data-hide-mobile="!this.internal_config.showMobile"
       :config-properties="JSON.stringify(internal_config)" :style="style()" v-on:click="focusElement($event)">

    <vue-draggable-resizable v-bind:w="parseInt(internal_config.width)" v-bind:h="150"
                             @resizing="onResize" :draggable="false" ref="draggableResizable">
      <!-- <rotate :target="this.$refs.draggableResizable" :config="this.internal_config" /> -->
      <options-element-bar ref="optionsBar" :elem="this"
                           name='ct-component-BlogCategoriesListComponent'></options-element-bar>

      <div v-if="categories.length > 0">
        <div class="desktop-element"  :style="titleStyle()" v-for="category in categories" :key="category.id">
          <span class="category-list" :style="titleStyle()">{{ category.name }}  </span> <br>
        </div>
        <div class="mobile-element" v-for="category in categories"  :style="titleStyleMobile()" :key="category.id">
          <span class="category-list" :style="titleStyleMobile()">{{ category.name }} </span> <br>
        </div>
      </div>
      <div v-else>
        <div style="background-color: white; height: 300px; width: 100%; display: flex; align-items: center; justify-content: center; flex-direction: column">
          <h6 class="text-center">{{ $t('ct-no-'+ internal_config.type +'-on-your-blog') }}</h6>
          <span>{{ $t('ct-helper-create-'+ internal_config.type) }}</span>
        </div>
      </div>

      <resources ref="resourcesData"></resources>
    </vue-draggable-resizable>
  </div>
</template>

<script>

import elementData from './Model';
import OptionsElementBar from '../../OptionsElementBar';
import Resources from './Resources.vue';
import { getChilds } from '../../../../../js/services/editor/blog.js';
import _ from 'lodash';

export default {
  name: 'BlogCategoriesListComponent',
  props: ['config', 'id'],
  components: {OptionsElementBar, Resources},
  data() {
    return elementData.data();
  },
  methods: {
    handler: function(e) {
      this.$root.$emit('focusElement', this);
      this.$root.$emit('handlerElement', this, true);
      e.stopPropagation();
      e.preventDefault();
    },
    focusElement(e) {
      this.$root.$emit('focusElement', this);
      this.$root.$emit('handlerElement', this);

      e.stopPropagation();
      e.preventDefault();
    },
    onResize: function(x, y, width, height) {
      this.internal_config.width = width + 'px';
      this.internal_config.height = height + 'px';

      this.$refs.resourcesData.setValuesData(this);
    },
    build(config) {
      this.internal_config = _.merge(this.internal_config, config);

    },
    animation() {
      return false;
    },
    showResources() {
      return this.$refs.resourcesData.getValuesData();
    },

    titleStyle() {
      return `font-family:  ${this.internal_config.titleStyle.family};
                  font-size: ${this.internal_config.titleStyle.size};
                  text-align: ${this.internal_config.titleStyle.align};
                  font-weight: ${this.internal_config.titleStyle.weight};
                  font-style: ${this.internal_config.titleStyle.style};
                  text-decoration: ${this.internal_config.titleStyle.stroke};
                  cursor: pointer;
                  line-height: unset;
                  height: auto;
                  color: ${this.internal_config.titleStyle.color}`;
    },

    titleStyleMobile() {
      return `font-family:  ${this.internal_config.titleStyle.family};
                  font-size: ${this.internal_config.titleStyle.sizeMobile} !important;
                  text-align: ${this.internal_config.titleStyle.align};
                  font-weight: ${this.internal_config.titleStyle.weight};
                  font-style: ${this.internal_config.titleStyle.style};
                  text-decoration: ${this.internal_config.titleStyle.stroke};
                  cursor: pointer;
                  line-height: unset;
                  height: auto;
                  color: ${this.internal_config.titleStyle.color}`;
    },

    // style methods

    style() {
      let {
        left,
        zIndex,
        paddingTop,
        paddingLeft,
        paddingRight,
        paddingBottom,
        top
      } = this.internal_config;

      let style = `left:  ${left};
                     z-index: ${zIndex};max-width: ${this.internal_config.maxWidth};margin: 0 auto;
                     padding-top: ${paddingTop};
                     padding-left: ${paddingLeft};
                     padding-right: ${paddingRight};
                     padding-bottom: ${paddingBottom};
					          top: ${top}`;

      document.documentElement.style.setProperty('--color-hover', this.internal_config.colorReadMore);

      return style;
    }
  },
  created() {
    let device, childs, id, config;
    ({device, childs, id, config} = this.$props);
    this.internal_config = config;
    this.device = device;
    if (typeof id !== 'undefined') {
      this.id = id;
    }
    this.internal_config = window.mergeRecursive(
      this.props,
      this.$props.config
    );
  },
  mounted() {
    let vm = this;

    this.build(this.$props.config);
    this.$root.$on('setConfigElement', (id, obj) => {
      if (this.id == id) {
        this.config = obj;
        this.internal_config = obj;
      }
    });

    getChilds('?type=' + this.internal_config.type)
      .then((res) => {
        this.categories = res.data;
      });

    this.$refs.resourcesData.setValuesData(this);
    document.documentElement.style.setProperty('--color-hover', this.internal_config.colorReadMore);

    let objIds = [];
    $('[id]').each(function() {
      var ids = $('[id="' + this.id + '"]');
      if (ids.length > 1 && ids[0] == this && parseInt(this.id)) { objIds.push(this.id) }
    });
    if (objIds.includes(this.id)) {
      this.id = Date.now() + parseInt(Math.random() * 10000);
    }
  },
  watch: {
    'internal_config': {
      deep: true,
      handler(value) {
        this.$eventHub.setValueElementConfig(this.id, value);
        this.$eventPointer.log(this.id, value);
      }
    }
  }
};
</script>

<style>

  [element="BlogCategoriesListComponent"] .vdr {
    height: auto !important;

  }

  .category-list:hover{
    color: var(--color-hover) !important;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Blog/Categories/CategoriesList.vue